import React, { useEffect } from 'react';
import ContactForm from './ContactForm';
import CompanyImg from '../assets/images/company.png';
import { PhoneOutlined, BankOutlined, EnvironmentOutlined } from '@ant-design/icons';

import './less/index.less';
import '../assets/styles/less/singlePage.less';



const ContactUs = () => {

    useEffect(() => {
        window.scrollTo(0, 0)
    });

    
    return (
        <div className="main">
            <div className="container">
                <div className="page-title">
                    <h1>تماس با ما</h1>
                </div>
                <h5 className="page-subtitle">
                    اگر سوال، انتقاد یا پیشنهادی دارید، ما از این‌جا صدای شما را می‌شنویم.
                </h5>
                <ContactForm />

                <div className="company-box">
                    <img src={CompanyImg} alt="شرکت" />
                    <div className="info-box">
                        <div className="info-item">
                            <PhoneOutlined />
                            <span>
                                تلفن :
                                <span>
                                    0912-9286079
                                </span>
                            </span>
                        </div>
                        <div className="info-item">
                            <PhoneOutlined />
                            <span>
                                پست الکترونیکی :
                                <span>
                                    info@madtalk.ir
                                </span>
                            </span>
                        </div>
                        <div className="info-item">
                            <BankOutlined />
                            <span>
                                کدپستی :
                                <span>
                                    ۱۹۱۷۷۱۷۵۵۳
                                </span>
                            </span>
                        </div>
                        <div className="info-item">
                            <EnvironmentOutlined />
                            <span>
                                آدرس :
                                <span>
                                آدرس : تهران، خیابان مطهری، خیابان میرزای شیرازی، کوچه مقدم، پلاک ۱۵
                                </span>
                            </span>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}
export default ContactUs;